import { render, staticRenderFns } from "./SyncSimpleFacturaDialog.vue?vue&type=template&id=7b958b66&scoped=true&"
import script from "./SyncSimpleFacturaDialog.vue?vue&type=script&lang=js&"
export * from "./SyncSimpleFacturaDialog.vue?vue&type=script&lang=js&"
import style0 from "./SyncSimpleFacturaDialog.vue?vue&type=style&index=0&id=7b958b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b958b66",
  null
  
)

export default component.exports